export default {
  comments: [],
}
